import React from 'react';
import { motion } from 'framer-motion';
import { ScissorsIcon } from 'lucide-react';
import { Divider } from './ui/Divider';
export function StorySection() {
  return <section id="inicio" className="bg-delux-bg py-20 px-4 sm:px-6 lg:px-8" data-id="element-309">
      <div className="max-w-3xl mx-auto" data-id="element-310">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-center text-center mb-12" data-id="element-311">
          <ScissorsIcon className="w-8 h-8 text-delux-gold mb-6" data-id="element-312" />
          <h2 className="font-heading text-2xl md:text-3xl text-delux-white leading-relaxed" data-id="element-313">
            Lee esto antes de reservar tu próximo corte en cualquier barbería de
            Lehigh Acres...
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="font-body text-lg md:text-xl text-delux-body leading-loose space-y-6" data-id="element-314">
          <p data-id="element-315">Ya sabes cómo se siente.</p>

          <p data-id="element-316">
            Te sientas en la silla. Explicas lo que quieres. El barbero asiente
            — quizás a medias — y 20 minutos después estás mirando una versión
            de ti mismo que está... bien.
          </p>

          <p data-id="element-317">
            No increíble. No impecable. No el hombre que imaginabas cuando
            entraste.
          </p>

          <p data-id="element-318">Y dejas propina de todas formas. Sales. Sigues con tu vida.</p>

          <p data-id="element-319">
            Pero algo queda. Una frustración silenciosa que no puedes nombrar
            del todo.
          </p>

          <p data-id="element-320">
            Querías sentirte diferente al salir. Querías mirarte al espejo y ver
            al hombre que eres por dentro — seguro, elegante, presentable —
            reflejado por fuera.
          </p>

          <p className="text-delux-gold font-medium text-xl md:text-2xl pt-4" data-id="element-321">
            En cambio, recibiste un recorte.
          </p>
        </motion.div>
      </div>
      <Divider data-id="element-322" />
    </section>;
}